export { BottomConsoleBadgesComponent } from './bottom-console-badges.component';
